import React from 'react';
import PropTypes from 'prop-types';
import MuiSwitch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const StyledSwitch = styled(MuiSwitch)(({ theme }) => {
  return {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: `rgba(${theme.palette.primary.main}, 0.08)`,
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.main,
    },
  };
});

const Switch = ({ color = 'primary', size = 'medium', ...props }) => {
  return <StyledSwitch color={color as any} size={size as any} {...props} />;
};

Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),
  size: PropTypes.oneOf(['small', 'medium']),
};

export default Switch;
